<template>
    <as-modal title="Providing Your Bank Details" @close="$emit('close', $event)">
        <p>{{client}} uses the information AccountScore receives from your bank to verify your income to help you complete your application. This service also speeds up the application process, giving you quicker access to the service without having to upload additional documents.</p>
    </as-modal>
</template>

<script>
    import AsModal from '../Ui/AsModal.vue'
    import settingsHelper from "@/store/modules/settings/helper.ts"
    const settingsHelpers = settingsHelper.mapGetters(["client"])
    export default {
        name: 'ProvidingYourBankDetails',
        components: {
            AsModal,
        },
        computed: {
            ...settingsHelpers
        }
    }
</script>
